import ClientFamilyCorpTable from "./ClientFamilyCorpTable";
import PageWrapper from "app/components/PageWrapper";
import { ServerSidePaginationContextProvider } from "shared/contexts/ServerSidePaginationContext";

const ClientFamilyCorp = () => {
    return (
        <PageWrapper
            title="Client Families"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <ServerSidePaginationContextProvider>
                <ClientFamilyCorpTable />
            </ServerSidePaginationContextProvider>
        </PageWrapper>
    );
};

export default ClientFamilyCorp;
